const testimonials = [
  {
    name: "David L.",
    location: "Bismarck, ND",
    rating: 5,
    text: "I'm a state employee and needed my passport renewed fast for an overseas conference. Fast Passport Center came through in 7 days. Saved me a 13-hour round trip to Denver. Incredible service for the Bismarck area.",
    trip: "Government conference abroad",
  },
  {
    name: "Jennifer M.",
    location: "Mandan, ND",
    rating: 5,
    text: "Living across the river from Bismarck, I used Fast Passport Center for my first passport ever. They guided me through every step, scheduled my post office visit, and delivered in 8 days. Couldn't believe how easy it was.",
    trip: "Caribbean cruise",
  },
  {
    name: "Brian O.",
    location: "Bismarck, ND",
    rating: 5,
    text: "Emergency renewal after losing my passport three weeks before my flight to Germany. Fast Passport Center prepared everything, caught two errors I had made, and had my new passport to me in 5 days. Absolutely lifesaving.",
    trip: "Business travel to Frankfurt",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Customer Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Bismarck Travelers Say About Us
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Real reviews from Bismarck and central North Dakota passport customers.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-7 flex flex-col">
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-200">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                  <i className="ri-user-line text-[#1A365D]"></i>
                </div>
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location} &middot; {t.trip}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}